import { config } from '@/app/config';
import { Icon, Logo } from '@/components/ui';

const DEFAULT_HEADING = 'Where students and companies find each other.';

const DEFAULT_POINTS = [
  'One verified profile for every application',
  'Internships matched to your skills',
  'Interviews, offers and messages in one place',
];

/**
 * The night-purple half of every sign-in and sign-up screen: the Wonder
 * mark, one line on what the product is, and three reasons to be here.
 *
 * Shared so the login page and the registration, password and verification
 * pages read as one door into the product. Each page may speak to its own
 * reader with `heading` and `points`; on a phone the panel shrinks to a strip
 * with the mark, so the form is still the first thing in reach.
 */
export function BrandPanel({ heading = DEFAULT_HEADING, points = DEFAULT_POINTS }) {
  return (
    <div className="bg-night text-on-night relative overflow-hidden p-6 sm:p-10 lg:p-12">
      <div
        aria-hidden="true"
        className="bg-iris-600/30 pointer-events-none absolute -top-24 -left-20 size-80 rounded-full blur-3xl"
      />
      <div
        aria-hidden="true"
        className="bg-iris-500/20 pointer-events-none absolute -right-24 -bottom-32 size-80 rounded-full blur-3xl"
      />

      <div className="relative flex h-full flex-col">
        <div className="flex items-center gap-3">
          <Logo size={44} />
          <span className="text-lg font-semibold tracking-tight">{config.appName}</span>
        </div>

        <div className="hidden flex-1 flex-col justify-center py-12 lg:flex">
          <h2 className="font-tight text-3xl leading-tight font-semibold">{heading}</h2>
          <ul className="mt-8 space-y-4">
            {points.map((point) => (
              <li key={point} className="text-on-night-muted flex items-start gap-3 text-sm">
                <span className="bg-nav-active/20 text-nav-active mt-0.5 grid size-5 shrink-0 place-items-center rounded-full">
                  <Icon name="check" size={12} />
                </span>
                {point}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
